import { render, staticRenderFns } from "./teamplan.vue?vue&type=template&id=22955a68&scoped=true&"
import script from "./teamplan.vue?vue&type=script&lang=js&"
export * from "./teamplan.vue?vue&type=script&lang=js&"
import style0 from "@/assets/components.scss?vue&type=style&index=0&id=22955a68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22955a68",
  null
  
)

export default component.exports